import {Component, OnDestroy, OnInit} from '@angular/core';
import {AnalogOutDescriptionDataservice} from "../../analogout/analogout-description-dataservice";
import {AnalogOutStatusDataservice} from "../../analogout/analogout-status-dataservice";
import {interval, Subscription} from "rxjs";
import {AnalyserStatusDataservice} from "../analyser-status-dataservice";
import {Analyser} from "../analyserStatus";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-analyser',
  templateUrl: './analyser.component.html',
  styleUrls: ['./analyser.component.css']
})
export class AnalyserComponent implements OnInit,OnDestroy {

  private updateSubscription: Subscription | undefined;
  analyser: Analyser;
  key: number = 0;

  constructor(private analyserStatusDataservice: AnalyserStatusDataservice             )  {
    this.analyser = new Analyser();
  }

  OnUp()
  {
    this.key = 8;
  }

  OnDown()
  {
    this.key = 1;
  }

  OnEnter()
  {
    this.key = 2;
  }

  OnGraph()
  {
    this.key = 4;
  }

  UpdateKey(): void {
    this.analyserStatusDataservice.PutKey(this.key).subscribe(     {
      next: analyser => {
        this.analyser = analyser;
      }
    });
    this.key = 0;
  }

  ngOnInit(): void {
    this.UpdateKey();
    this.updateSubscription = interval(environment.interval).subscribe(
      (val) => {
        this.UpdateKey();
      }
    );
  }
  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }

}
